import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { AppService } from './app.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from './localstorage.service';
import { Observable } from 'rxjs';
import { map, tap, switchAll } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { NativeService } from 'src/app/providers/NativeService';
import { File, FileEntry, DirectoryEntry, FileError, RemoveResult } from '@ionic-native/file/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { Device } from '@ionic-native/device/ngx';
@Injectable({
  providedIn: 'root'
})
export class FileService {
	isH5 = JSON.parse(this.localStorageService.getStore('isH5'));
	isMobileWeb = this.nativeService.isMobileWeb();
  constructor(
    private dataService: DataService, 
		public appService: AppService,
    public localStorageService: LocalStorageService,
    private translateService: TranslateService,
		private nativeService: NativeService,
    private file: File,
    // private fileTransfer: FileTransfer,
    private http: HttpClient,
    private androidPermissions: AndroidPermissions,
    private device: Device) {
  }

  getFileStream(url: string): Observable<any> {
    return this.http.get(url, {
      observe: 'response',
      responseType: 'arraybuffer'
    });
  }

  async getFileBlob(url: string): Promise<Blob> {
    const fileStream$ = this.getFileStream(url);
    return fileStream$.pipe(map(response => {
      return new Blob([response.body], { type: response.headers.get('content-type')});
    })).toPromise();
  }

  async getFileBlobPdf(url: string): Promise<Blob> {
    const fileStream$ = this.getFileStream(url);
    return fileStream$.pipe(map(response => {
      return new Blob([response.body], { type: 'application/pdf' });
    })).toPromise();
  }

  async getFileBlobOfType(url: string, type: any): Promise<Blob> {
    const fileStream$ = this.getFileStream(url);
    return fileStream$.pipe(map(response => {
      let nowType = '';
      if (type) {
        nowType = type.replace('.', ''); 
      }
      const imageType = ['jpg', 'jpge', 'png', 'gif', 'bmp', 'ico', 'webp', 'svg'];
      if (imageType.indexOf(nowType) !== 1) {
        return new Blob([response.body], { type: 'iamge/' + nowType });
      } else {
        return new Blob([response.body], { type: response.headers.get('content-type')});
      }
    })).toPromise();
  }

  async openFileBlob(url: string, filename: string) {
    const openUrl = URL.createObjectURL(await this.getFileBlob(url));
    const blobWindow = window.open();
    blobWindow.document.title = filename;
    blobWindow.document.write(`
      <iframe src="${openUrl}" style="width:100%; height:100%;"></iframe>
    `);
  }

  decodeFilenameFromUrl(url: string): string {
    const sections = url.split('/');
    const encodedFilename = sections[sections.length - 2];
    const decodedFilename = atob(encodedFilename);
    return decodedFilename;
  }

  downloadFileFromEncodedStream(url: string, fileName?: string, type?: string) {
    this.getFileStream(url).subscribe(fs => {
      const blob: Blob = new Blob([fs.body], { type: this.getApplication(type) });
      if (!this.isH5 && this.isMobileWeb) { // 网页端
        saveAs(blob, fileName);
      } else if (this.isH5 && this.isMobileWeb) { // 企业微信
        this.appService.toastTip('shared_components.select_file.format_not_supported', true);
        // this.downloadFileATag(fs.body, fileName, type);
      } else { // 独立app
        this.downloadAndSaveFileToDevice(blob, fileName);
      }
    });
  }

  // 创建a标签下载文件
  downloadFileATag(blobData, fileName, type) {
    const blob: Blob = new Blob([blobData], { type: this.getApplication(type) });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName; // 设置下载文件名和扩展名
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url); // 清理URL对象，避免内存泄漏
    a.remove(); // 移除创建的a元素
  }

  // 独立app下载文件
  downloadAndSaveFileToDevice(blob: Blob, fileName: string) {
    let fileDir = '';
    let subDir = 'DigitalEHS/';
    // 根据当前操作系统决定文件存储路径
    if (this.device.platform === 'iOS') {
      fileDir = this.file.documentsDirectory;
    } else if (this.device.platform === 'Android') {
      fileDir = this.file.externalRootDirectory + 'Download/';
    }
    const savedFileName = this.assembleUniqueFileName(fileName);
    // 安卓：请求文件读写权限
    this.androidPermissions.requestPermissions([
      this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE, 
      this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE
    ]).then(res => {
      this.file.checkDir(fileDir, subDir).then(dirExists => {
        if (dirExists && typeof window['resolveLocalFileSystemURL'] === 'function') {
          window['resolveLocalFileSystemURL'](fileDir + subDir, (directoryEntry: DirectoryEntry) => {
            directoryEntry.getFile(savedFileName, { create: true, exclusive: false }, (fileEntry: FileEntry) => {
              fileEntry.createWriter(fileWriter => {
                fileWriter.onwritestart = (startEvent: ProgressEvent) => {
                      // alert('文件保存开始: ' + JSON.stringify(startEvent));
                };
                fileWriter.onwriteend = (endEvent: ProgressEvent) => {
                  let successMessage = '';
                  if (this.device.platform === 'iOS') {
                    successMessage = 'FILE_MSG.FILE_SAVE_SUCCESS_IOS';
                  } else if (this.device.platform === 'Android') {
                    successMessage = 'FILE_MSG.FILE_SAVE_SUCCESS_ANDROID';
                  }
                  this.appService.toastTipSuccess(this.translateService.instant(successMessage) + savedFileName, false, 10000);
                };
                fileWriter.onerror = (errorEvent: ProgressEvent) => {
                  this.appService.toastTip(this.translateService.instant('FILE_MSG.FILE_SAVE_FAILED') + 'errorEvent' + JSON.stringify(errorEvent), false, 10000);
                };

                fileWriter.write(blob);
              }, (fileWriterError: FileError) => {
                this.appService.toastTip(this.translateService.instant('FILE_MSG.FILE_SAVE_FAILED') + 'fileWriterError' + JSON.stringify(fileWriterError), false, 10000);
              });
            }, (fileEntryError: FileError) => {
              this.appService.toastTip(this.translateService.instant('FILE_MSG.FILE_SAVE_FAILED') + 'fileEntryError' + JSON.stringify(fileEntryError), false, 10000);
            });
          }, (directoryEntryError: FileError) => {
            this.appService.toastTip(this.translateService.instant('FILE_MSG.FILE_SAVE_FAILED') + 'directoryEntryError' + JSON.stringify(directoryEntryError), false, 10000);
          });
        } else {
          this.appService.toastTip(this.translateService.instant('FILE_MSG.FILE_SAVE_FAILED') + '[typeof resolveLocalFileSystemURL: ' + typeof window['resolveLocalFileSystemURL'] + ']', false, 5000);
        }
      }, checkDirError => {
        if (checkDirError.message === 'NOT_FOUND_ERR') {
          this.file.createDir(fileDir, subDir, true).then((directoryEntry: DirectoryEntry) => {
            directoryEntry.getFile(savedFileName, { create: true, exclusive: false }, (fileEntry: FileEntry) => {
              fileEntry.createWriter(fileWriter => {
                fileWriter.onwritestart = (startEvent: ProgressEvent) => {
                  // alert('文件保存开始: ' + JSON.stringify(startEvent));
                };
                fileWriter.onwriteend = (endEvent: ProgressEvent) => {
                  let successMessage = '';
                  if (this.device.platform === 'iOS') {
                    successMessage = 'FILE_MSG.FILE_SAVE_SUCCESS_IOS';
                  } else if (this.device.platform === 'Android') {
                    successMessage = 'FILE_MSG.FILE_SAVE_SUCCESS_ANDROID';
                  }
                  this.appService.toastTipSuccess(this.translateService.instant(successMessage) + savedFileName, false, 10000);
                };
                fileWriter.onerror = (errorEvent: ProgressEvent) => {
                  this.appService.toastTip(this.translateService.instant('FILE_MSG.FILE_SAVE_FAILED') + JSON.stringify(errorEvent), false, 10000);
                };
                fileWriter.write(blob);
              }, (fileWriterError: FileError) => {
                this.appService.toastTip(this.translateService.instant('FILE_MSG.FILE_SAVE_FAILED') + JSON.stringify(fileWriterError), false, 10000);
              });
            }, (fileEntryError: FileError) => {
              this.appService.toastTip(this.translateService.instant('FILE_MSG.FILE_SAVE_FAILED') + JSON.stringify(fileEntryError), false, 10000);
            });
          }, (directoryEntryError: FileError) => {
            this.appService.toastTip(this.translateService.instant('FILE_MSG.FILE_SAVE_FAILED') + JSON.stringify(directoryEntryError), false, 10000);
          });
        }
      });
    }, permissionError => {
      this.appService.toastTip(this.translateService.instant('FILE_MSG.PERMISSION_NEEDED') + JSON.stringify(permissionError), false, 10000);
    });
  }

  private saveAndOpenFile(blob: Blob, fileName: string): void {
    this.file.writeFile(
      this.file.documentsDirectory,
      fileName,
      blob,
    ).then(() => {
			this.appService.toastTip('下载文件2', true);
    }).catch(err => {
			this.appService.toastTip('下载文件时出错2', true);
    });
  }

  private assembleUniqueFileName(fileName: string): string {
    let uniqueFileName = '';
    const fileNameArray = fileName.split('.');
    const timestamp = new Date().toISOString().replace(/:/g, '-');
    fileNameArray.forEach((section: string, index: number) => {
      if (index !== fileNameArray.length - 1) {
        uniqueFileName += (section + '.');
      }
    });
    uniqueFileName += timestamp;
    uniqueFileName += ('.' + fileNameArray[fileNameArray.length - 1]);
    return uniqueFileName;
  }

  getApplication(type?: string) {
    // 默认pdf
    let applicationSrc = 'application/octet-stream';
    if (type) {
      switch (type) {
        case '.pdf':
          applicationSrc = 'application/pdf';
          break;
        // case '.doc':
        //   applicationSrc = 'application/vnd.ms-word';
        //   break;
        // case '.docx':
        //   applicationSrc = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        //   break;
        // case '.xls':
        //   applicationSrc = 'application/vnd.ms-excel';
        //   break;
        // case '.xlsx':
        //   applicationSrc = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        //   break;
        // case '.ppt':
        //   applicationSrc = 'application/vnd.ms-powerpoint';
        //   break;
        // case '.pptx':
        //   applicationSrc = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
        //   break;
        default:
          applicationSrc = 'application/octet-stream';
      }
    }
    return applicationSrc;
  }
}
